// @flow

import styled, { css } from 'styled-components';

export default styled.div`
  width: 12rem;
  height: 12rem;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  z-index: 9;
  ${(props : any) => css`background-image: url(${props.backgroundImage});`}
  & > a {
    position: absolute;
    margin: auto;
    border: none;
    outline: none;
    cursor: pointer;
    background: transparent;
    display: block;
    overflow: hidden;
  }
  & > .up {
    top: -.05rem;
    left: 0;
    right: 0;  
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    width: 8.2rem;
    height: 3.9rem;
    &:hover {
      ${(props : any) => css`background-image: url(${props.upBackgroundImage});`}
    }
  }
  & > .right {
    top: 0;
    bottom: 0;
    right: -.05rem;
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    width: 3.9rem;
    height: 8.2rem;
    &:hover {
      ${(props : any) => css`background-image: url(${props.rightBackgroundImage});`}
    }
  }
  & > .down {
    bottom: -.05rem;
    left: 0;
    right: 0;
    width: 0;
    height: 0;
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    width: 8.2rem;
    height: 3.9rem;
    &:hover {
      ${(props : any) => css`background-image: url(${props.downBackgroundImage});`}
    }
  }
  & > .left {
    left: -.05rem;
    top: 0;
    bottom: 0;
    width: 0;
    height: 0;
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    width: 3.9rem;
    height: 8.2rem;
    &:hover {
      ${(props : any) => css`background-image: url(${props.leftBackgroundImage});`}
    }
  }
  & > .ok {
    width: 5rem;
    height: 5rem;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-size: 80% 80%;
    background-position: center center;
    background-repeat: no-repeat;
    &:hover {
      ${(props : any) => css`background-image: url(${props.okBackgroundImage});`}
    }
  }
  & > .center:hover {
    background: #ea1d5d;
  }
  & > .left:hover {
    border-color: transparent #ea1d5d transparent transparent;
  }
  & > .right:hover {
    border-color: transparent transparent transparent #ea1d5d;
  }
  & > .bottom:hover {
    border-color: #ea1d5d transparent transparent transparent;
  }
  & > .top:hover {
    border-color: transparent transparent #ea1d5d transparent;
  }

`;
